import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}
export const Reveal = ({
  children,
  delay = 0,
  y = 24,
  className = ''
}: RevealProps) => <motion.div initial={{
  opacity: 0,
  y
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-80px'
}} transition={{
  duration: 0.6,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} className={className} data-id="element-2433" data-mp="yf9sk28oehil">
    {children}
  </motion.div>;